import React from 'react'

const DashBoardHome = () => {
    return (
        <div className='flex flex-col text-center my-20'>
            <h1 className='text-5xl font-bold'>Welocome to dashboard</h1>
        </div>
    )
}

export default DashBoardHome